import { createContext, useContext } from 'react';
import type { BrandPresetId } from '@workspace/types';

export interface BrandThemeContextValue {
  presetId: BrandPresetId;
  brandName: string;
  logoUrl?: string;
  loaded: boolean;
  saving: boolean;
  setBrandPreset: (presetId: BrandPresetId) => Promise<void>;
}

export const BrandThemeContext = createContext<BrandThemeContextValue | null>(null);

export function useBrandTheme(): BrandThemeContextValue {
  const ctx = useContext(BrandThemeContext);
  if (!ctx) {
    throw new Error('useBrandTheme must be used within BrandThemeProvider');
  }
  return ctx;
}
